module.exports = __webpack_public_path__ + "img/apostrophe.6fb5b0de.svg";